import React, { ReactNode } from 'react';
import { Form } from 'react-bootstrap';

interface AccommodationInputSelectProps {
  children: ReactNode | ReactNode[];
  DefaultValue?: string;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  HandleChange: (event: any) => void;
  IsRequired?: boolean;
  LabelText: string;
  SelectId: string;
  SelectName?: string;
  Disabled?: boolean;
}

const AccommodationInputSelect = ({
  children,
  DefaultValue = null,
  HandleChange,
  IsRequired = true,
  LabelText,
  SelectId,
  SelectName = null,
  Disabled,
}: AccommodationInputSelectProps) => {
  return (
    <Form.Group className="mb-24">
      <Form.Label className={IsRequired ? 'required' : ''} htmlFor={SelectId}>
        {LabelText}
      </Form.Label>
      {Disabled && (
        <Form.Control plaintext readOnly defaultValue={DefaultValue} />
      )}
      {!Disabled && (
        <Form.Select
          disabled={Disabled}
          id={SelectId}
          required={IsRequired}
          onChange={HandleChange}
          name={SelectName !== null ? SelectName : SelectId}
          defaultValue={DefaultValue}
        >
          {children}
        </Form.Select>
      )}
    </Form.Group>
  );
};
export default AccommodationInputSelect;
export { AccommodationInputSelect };
export type { AccommodationInputSelectProps };
